




import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  SetupContext
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";
import WalletKey from "@/components/wallet-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }

    const globalStore = context.root.$store;

    memberStore.clearMember();
    walletStore.clearWalletList();
    walletStore.clearCompanyCodeList();
    walletStore.clearWalletHistoryList();

    globalStore.auth.executeLogout();
    context.root.$router.push({ name: "Login" });
  }
});
